import { applyMiddleware, compose, createStore } from 'redux'
import { thunk } from 'redux-thunk'
import makeRootReducer from './reducers'

const createState = (initialState = {}) => {
  const middleware = [thunk]

  const enhancers = []

  const _compose: any = compose
  const store: any = createStore(
    makeRootReducer({}),
    initialState,
    _compose(applyMiddleware(...middleware), ...enhancers),
  )
  store.asyncReducers = {}

  if (import.meta.hot) {
    import.meta.hot.accept('./reducers', async () => {
      const { default: reducers } = await import('./reducers')
      store.replaceReducer(reducers(store.asyncReducers))
    })
  }

  return store
}
export default createState
